import { gql } from "@apollo/client";

export const GET_ALL_CUSTOMER_PHONE_NUMBERS = gql`
query adminGetAllCustomerPhoneNumbers {
  adminGetAllCustomerPhoneNumbers {
    status
    error
    customers {
      customerid
      firstname
      lastname
      phone
    }
  }
}`;

export const GET_LOCKED_CUSTOMER_PHONE_NUMBERS = gql`
query adminGetLockedCustomerPhoneNumbers {
  adminGetLockedCustomerPhoneNumbers {
    status
    error
    customers {
      customerid
      firstname
      lastname
      phone
    }
  }
}`;

export const GET_DISPUTED_CUSTOMER_PHONE_NUMBERS = gql`
query adminGetDisputedCustomerPhoneNumbers {
  adminGetDisputedCustomerPhoneNumbers {
    status
    error
    customers {
      customerid
      firstname
      lastname
      phone
    }
  }
}`;

export const GET_CUSTOMER_BY_ID = gql`
query adminGetCustomerById ($customerid: String!) {
  adminGetCustomerById (customerid: $customerid) {
    status
    error
    customer {
      customerid
      firstname
      lastname
      address1
      address2
      city
      state
      zip
      phone
      email
      country
      gender
      datetimecreated
      datetimeupdated
      birthdate
      active
      plaidverified
    }
  }
}`;